import { motion } from "framer-motion";

/* Temporary Halloween accents: large translucent "glass" bats drifting around
   the date card. Original SVG silhouette. */

const BAT_PATH =
  "M60 18c2.6-5.4 5.8-6.6 7.6-5.8l1 4.6 2.2-3.2c10.4.8 21.6 6 31.2 18.2-6-2.6-10.8-1.8-13.8 1.2-3.4-3.8-8.2-4.2-12-1.2-2.6-3-6.8-3.8-10.4-1.4L60 41l-5.8-10.6c-3.6-2.4-7.8-1.6-10.4 1.4-3.8-3-8.6-2.6-12 1.2-3-3-7.8-3.8-13.8-1.2C27.6 19.6 38.8 14.4 49.2 13.6l2.2 3.2 1-4.6C54.2 11.4 57.4 12.6 60 18z";

const Bat = ({ className, width, delay = 0, drift = 10, rotate = 0 }) => (
  <motion.svg
    viewBox="0 0 120 50"
    className={`absolute ${className}`}
    style={{ width, rotate }}
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1, y: [0, -drift, 0], x: [0, drift / 2, 0] }}
    transition={{
      opacity: { duration: 1.6, delay },
      scale: { duration: 1.6, delay },
      y: { duration: 7, delay, repeat: Infinity, ease: "easeInOut" },
      x: { duration: 9, delay, repeat: Infinity, ease: "easeInOut" },
    }}
  >
    <path className="hw-flap" style={{ animationDelay: `${delay}s` }} d={BAT_PATH}
      fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.22)" strokeWidth="0.8" strokeLinejoin="round" />
  </motion.svg>
);

export const HalloweenGlow = () => (
  <div className="pointer-events-none absolute -inset-8 rounded-[2.5rem] bg-[radial-gradient(closest-side,rgba(255,122,26,0.14),transparent)] blur-2xl" aria-hidden="true" />
);

export const HalloweenAccents = () => (
  <div className="pointer-events-none absolute inset-0 z-10" aria-hidden="true" data-testid="halloween-accents">
    <Bat className="-top-16 -left-28 sm:-left-44" width={150} delay={2} drift={12} rotate={-10} />
    <Bat className="-bottom-10 -right-24 sm:-right-40" width={120} delay={2.4} drift={10} rotate={12} />
    <Bat className="-top-14 -right-10 sm:-right-24 hidden sm:block" width={80} delay={2.8} drift={8} rotate={6} />
  </div>
);
